import { render, staticRenderFns } from "./choosePeopleMore.vue?vue&type=template&id=433f284d&scoped=true&"
import script from "./choosePeopleMore.vue?vue&type=script&lang=ts&"
export * from "./choosePeopleMore.vue?vue&type=script&lang=ts&"
import style1 from "./choosePeopleMore.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433f284d",
  null
  
)

export default component.exports